export const MAX_MAKER_LICENSES_COUNT = 3;

export const MAX_MAKER_LICENSE_SESSIONS_COUNT = 1;
